/* tslint:disable */
/* eslint-disable */
/**
 * B2B Homes
 * Endpoints needed to book and cancel homes. API models for homes checkout are returned \" +  \"via purchase APIs defined in b2b-interfaces under \'B2B Purchase.\'  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.cancel.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `product`, `tenantid` * `b2bportal.cancel.success`   * tags: `api_version`, `cancel_scenario`, `product`, `tenantid` * `b2bportal.homes.getCities.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.homes.getCities.success`   * tags: `api_version`, `tenantid` * `b2bportal.homes.shop.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.homes.shop.success`   * tags: `api_version`, `tenantid` * `b2bportal.mytrips.get.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.quote.cancel.product.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `product`, `tenantid` * `b2bportal.quote.cancel.product.success`   * tags: `api_version`, `cancel_scenario`, `product`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid`   # Tracking Error Codes * `bad_request` * `fulfillment_error` * `internal_error` * `product_not_found` * `request_deserialization_error` * `response_serialization_error` * `service_error` * `unknown`  # Cancel Scenarios * `agent_review_and_fulfillment` * `canceled` * `contact_customer_service` * `fully_refundable` * `non_refundable` * `partially_refundable` * `past_check_in_date`
 *
 * The version of the OpenAPI document: v2p21
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * @type Aborted
 * @export
 */
export type Aborted = { Aborted: 'ProductFailure' } & ProductFailure | { Aborted: 'RefundFailure' } & RefundFailure | { Aborted: 'UnknownFailure' } & UnknownFailure;

export const AbortedEnum = {
    ProductFailure: 'ProductFailure',
    RefundFailure: 'RefundFailure',
    UnknownFailure: 'UnknownFailure'
} as const;

export type AbortedEnum = typeof AbortedEnum[keyof typeof AbortedEnum];


/**
 * @type AcceptedCreditCard
 * @export
 */
export type AcceptedCreditCard = { AcceptedCreditCard: 'AcceptedList' } & AcceptedCreditCardAcceptedList | { AcceptedCreditCard: 'Unknown' } & AcceptedCreditCardUnknown;

export interface AcceptedCreditCardAcceptedList {
    'cards': Array<CardType>;
    'AcceptedCreditCard': AcceptedCreditCardEnum;
}


export const AcceptedCreditCardEnum = {
    AcceptedList: 'AcceptedList',
    Unknown: 'Unknown'
} as const;

export type AcceptedCreditCardEnum = typeof AcceptedCreditCardEnum[keyof typeof AcceptedCreditCardEnum];


export interface AcceptedCreditCardUnknown {
    'AcceptedCreditCard': AcceptedCreditCardEnum;
}


export interface AccountPrice {
    'currency': string;
    'value': number;
    'currencyDescription'?: string;
}
/**
 * policy result for homes cancellation when it requires an agent to review and cancel

 * `cancelCopy` - Copy to explain the process for submitting a request to an agent for review.
 * `cancelConfirmationCopy` - Copy to be displayed when the user is confirming/submitting their cancellation request.
 * `cancellationPolicyTitle` - Cancellation policy title to be displayed when providing the cancellation policy for the booking.
 * `cancellationPolicyBody` - Detailed cancellation policy to display to the user.
 * @export
 * @interface AgentReviewAndFulfillment
 */
export interface AgentReviewAndFulfillment {
    'cancelConfirmationCopy': Copy;
    /**
     * Cancellation policy title to be displayed when providing the cancellation policy for the booking.
     * @type {string}
     * @memberof AgentReviewAndFulfillment
     */
    'cancellationPolicyTitle': string;
    /**
     * Detailed cancellation policy to display to the user.
     * @type {string}
     * @memberof AgentReviewAndFulfillment
     */
    'cancellationPolicyBody': string;
    'cancelCopy': Copy;
    'HomesCancelScenario': HomesCancelScenarioEnum;
}


export interface Airport {
    'RegionType': RegionTypeEnum;
}


/**
 * Airport region for the listing location
 * @export
 * @interface AirportRegion
 */
export interface AirportRegion {
    'regionType': RegionType;
    'code': string;
}
/**
 * `amenityKind` - Specific amenity kind to filter by
 * @export
 * @interface AmenityFilter
 */
export interface AmenityFilter {
    'amenityKind': AmenityKind;
}


/**
 * Specific amenity kind to filter by
 * @export
 * @enum {string}
 */

export const AmenityKind = {
    Accessibility: 'Accessibility',
    AccessibleBathroom: 'AccessibleBathroom',
    AccessibleFacilities: 'AccessibleFacilities',
    AirConditioning: 'AirConditioning',
    AllergyFriendly: 'AllergyFriendly',
    BarInBuilding: 'BarInBuilding',
    BarbecueGrill: 'BarbecueGrill',
    Bathtub: 'Bathtub',
    BeachFront: 'BeachFront',
    BeachView: 'BeachView',
    BedLinens: 'BedLinens',
    Bicycle: 'Bicycle',
    BoardGames: 'BoardGames',
    Cable: 'Cable',
    CarbonMonoxideAlarm: 'CarbonMonoxideAlarm',
    CeilingFan: 'CeilingFan',
    CityView: 'CityView',
    CleaningProducts: 'CleaningProducts',
    Coffee: 'Coffee',
    CoffeeMaker: 'CoffeeMaker',
    CoffeeTea: 'CoffeeTea',
    ConvenientCheckInOut: 'ConvenientCheckInOut',
    CookingBasics: 'CookingBasics',
    Crib: 'Crib',
    DedicatedWorkspace: 'DedicatedWorkspace',
    DiningTable: 'DiningTable',
    DishesAndSilverware: 'DishesAndSilverware',
    Dishwasher: 'Dishwasher',
    DoormanEntry: 'DoormanEntry',
    Dryer: 'Dryer',
    Elevator: 'Elevator',
    Entertainment: 'Entertainment',
    Essentials: 'Essentials',
    EvCharger: 'EvCharger',
    ExtraPillowsAndBlankets: 'ExtraPillowsAndBlankets',
    FireExtinguisher: 'FireExtinguisher',
    FirePit: 'FirePit',
    Fireplace: 'Fireplace',
    FirstAidKit: 'FirstAidKit',
    FitnessCenter: 'FitnessCenter',
    FreeParking: 'FreeParking',
    Freezer: 'Freezer',
    FrontDesk: 'FrontDesk',
    GamingConsole: 'GamingConsole',
    GardenOrBackyard: 'GardenOrBackyard',
    Gym: 'Gym',
    HairDryer: 'HairDryer',
    Hangers: 'Hangers',
    Hdtv: 'Hdtv',
    Heating: 'Heating',
    HighChair: 'HighChair',
    HotTub: 'HotTub',
    HotWater: 'HotWater',
    HotWaterKettle: 'HotWaterKettle',
    Housekeeping: 'Housekeeping',
    InternetAccess: 'InternetAccess',
    Iron: 'Iron',
    Kayak: 'Kayak',
    KidFriendly: 'KidFriendly',
    Kitchen: 'Kitchen',
    Kitchenette: 'Kitchenette',
    Laundry: 'Laundry',
    MealAvailable: 'MealAvailable',
    Microwave: 'Microwave',
    MountainView: 'MountainView',
    NatureView: 'NatureView',
    OnDemandHousekeeping: 'OnDemandHousekeeping',
    OutdoorSeating: 'OutdoorSeating',
    OutdoorSpace: 'OutdoorSpace',
    Oven: 'Oven',
    PaidParking: 'PaidParking',
    Parking: 'Parking',
    PatioOrBalcony: 'PatioOrBalcony',
    PetFriendly: 'PetFriendly',
    Piano: 'Piano',
    PingPongTable: 'PingPongTable',
    Pool: 'Pool',
    PoolTable: 'PoolTable',
    PrivateEntrance: 'PrivateEntrance',
    PropertyView: 'PropertyView',
    Refrigerator: 'Refrigerator',
    RestaurantInBuilding: 'RestaurantInBuilding',
    Sauna: 'Sauna',
    SecureEntry: 'SecureEntry',
    SecureStorage: 'SecureStorage',
    SecuritySystem: 'SecuritySystem',
    Shampoo: 'Shampoo',
    SkiInSkiOut: 'SkiInSkiOut',
    SmokeAlarm: 'SmokeAlarm',
    SmokingAllowed: 'SmokingAllowed',
    SoundSystem: 'SoundSystem',
    Stove: 'Stove',
    StreetParking: 'StreetParking',
    Toaster: 'Toaster',
    Unrecognized: 'Unrecognized',
    Unspecified: 'Unspecified',
    WardrobeOrCloset: 'WardrobeOrCloset',
    Washer: 'Washer',
    WaterView: 'WaterView',
    Waterfront: 'Waterfront',
    Wifi: 'Wifi'
} as const;

export type AmenityKind = typeof AmenityKind[keyof typeof AmenityKind];


/**
 * A monetary amount
 * @export
 * @interface Amount
 */
export interface Amount {
    'amount': number;
    'currency': string;
}
export interface Approximate {
    'Specificity': SpecificityEnum;
}


export const Assistance = {
    BLND: 'BLND',
    DEAF: 'DEAF',
    STCR: 'STCR',
    WCBD: 'WCBD',
    WCBW: 'WCBW',
    WCHC: 'WCHC',
    WCHR: 'WCHR',
    WCHS: 'WCHS',
    WCLB: 'WCLB',
    WCMP: 'WCMP',
    WCOB: 'WCOB'
} as const;

export type Assistance = typeof Assistance[keyof typeof Assistance];


/**
 * 

* `AVAILABLE_FIRST` - Return all matching listings available and unavailable listings, sorting available listings first. This will exclude listings that return an availability error.
* `AVAILABLE_ONLY` - Only return matching available listings.
* `UNAVAILABLE_ONLY` - Only return matching unavailable listings. This will exclude listings that return an availability error.
* `Unspecified` - Unspecified search mode, defaults to AVAILABLE_ONLY in homes-demand-api
 * @export
 * @enum {string}
 */

export const AvailabilityMode = {
    AVAILABLE_FIRST: 'AVAILABLE_FIRST',
    AVAILABLE_ONLY: 'AVAILABLE_ONLY',
    UNAVAILABLE_ONLY: 'UNAVAILABLE_ONLY',
    Unspecified: 'Unspecified'
} as const;

export type AvailabilityMode = typeof AvailabilityMode[keyof typeof AvailabilityMode];


/**
 * @type AvailabilityRequest
 * Request available Homes and prices
 * @export
 */
export type AvailabilityRequest = { AvailabilityRequest: 'Empty' } & Empty | { AvailabilityRequest: 'FollowupSearch' } & FollowupSearch | { AvailabilityRequest: 'InitialSearch' } & InitialSearch;

export const AvailabilityRequestEnum = {
    Empty: 'Empty',
    FollowupSearch: 'FollowupSearch',
    InitialSearch: 'InitialSearch'
} as const;

export type AvailabilityRequestEnum = typeof AvailabilityRequestEnum[keyof typeof AvailabilityRequestEnum];


/**
 * `listings` - List of listings that match the search criteria
 * `nextPageToken` - Token to be used to fetch the next page of results
 * @export
 * @interface AvailabilityResponse
 */
export interface AvailabilityResponse {
    /**
     * List of listings that match the search criteria
     * @type {Array<ListingSearchResult>}
     * @memberof AvailabilityResponse
     */
    'listings': Array<ListingSearchResult>;
    'nextPageToken'?: SearchPageToken;
    'trackingProperties'?: TrackingProperties;
}
export interface AvailabilityResponseFailure {
    'errors': Array<ErrorCode>;
    'Response': ResponseEnum;
}


/**
 * @type AvailabilityResponseResponse
 * @export
 */
export type AvailabilityResponseResponse = { Response: 'Failure' } & AvailabilityResponseFailure | { Response: 'Success' } & AvailabilityResponseSuccess;

export interface AvailabilityResponseSuccess {
    'value': AvailabilityResponse;
    'Response': ResponseEnum;
}


/**
 * @type AvailabilityResult
 * Whether the listing is available or unavailable for the given search criteria
 * @export
 */
export type AvailabilityResult = { AvailabilityResult: 'Available' } & AvailabilityResultAvailable | { AvailabilityResult: 'Empty' } & AvailabilityResultEmpty | { AvailabilityResult: 'Error' } & AvailabilityResultError | { AvailabilityResult: 'Unavailable' } & AvailabilityResultUnavailable;

/**
 * The listing is available for the given search criteria.
 * @export
 * @interface AvailabilityResultAvailable
 */
export interface AvailabilityResultAvailable {
    'rate': Rate;
    'AvailabilityResult': AvailabilityResultEnum;
}


/**
 * Unknown availability.
 * @export
 * @interface AvailabilityResultEmpty
 */
export interface AvailabilityResultEmpty {
    'AvailabilityResult': AvailabilityResultEnum;
}


export const AvailabilityResultEnum = {
    Available: 'Available',
    Empty: 'Empty',
    Error: 'Error',
    Unavailable: 'Unavailable'
} as const;

export type AvailabilityResultEnum = typeof AvailabilityResultEnum[keyof typeof AvailabilityResultEnum];


/**
 * Unknown availability due to the returned error.
 * @export
 * @interface AvailabilityResultError
 */
export interface AvailabilityResultError {
    'debugDetails'?: string;
    'AvailabilityResult': AvailabilityResultEnum;
}


/**
 * The listing is unavailable for the given search criteria due to the returned reason.
 * @export
 * @interface AvailabilityResultUnavailable
 */
export interface AvailabilityResultUnavailable {
    'reasons': Array<UnavailabilityReason>;
    'AvailabilityResult': AvailabilityResultEnum;
}


export interface Bathroom {
    'name': string;
    'description'?: string;
}
export interface BedType {
    'name': string;
    'count': number;
}
export interface Bedroom {
    'name': string;
    'description'?: string;
    'bedTypes': Array<BedType>;
}
export interface CalendarDay {
    'date': string;
    'isAvailable': boolean;
}
/**
 * Policy result for homes already in a canceled status

 * `cancelCopy` - Copy to inform the user the booking has already been canceled.
 * @export
 * @interface Canceled
 */
export interface Canceled {
    'cancelCopy': Copy;
    'HomesCancelScenario': HomesCancelScenarioEnum;
}


export interface CancellationPenalty {
    'penalty': Penalty;
}
export interface CancellationPolicy {
    'policy': Policy;
    'isRefundable'?: boolean;
}
export interface CancellationPolicyForFE {
    'policy': CancellationPolicyForFEPolicy;
}
/**
 * @type CancellationPolicyForFEPolicy
 * @export
 */
export type CancellationPolicyForFEPolicy = { Policy: 'FullyRefundable' } & PolicyFullyRefundable | { Policy: 'NonRefundable' } & PolicyNonRefundableFE | { Policy: 'PartiallyRefundable' } & PolicyPartiallyRefundable | { Policy: 'Unknown' } & PolicyUnknown;

export const CancellationPolicyForFEPolicyEnum = {
    FullyRefundable: 'FullyRefundable',
    NonRefundable: 'NonRefundable',
    PartiallyRefundable: 'PartiallyRefundable',
    Unknown: 'Unknown'
} as const;

export type CancellationPolicyForFEPolicyEnum = typeof CancellationPolicyForFEPolicyEnum[keyof typeof CancellationPolicyForFEPolicyEnum];


export interface CancellationScheduleStep {
    'penalty': CancellationPenalty;
    'start'?: string;
    'end'?: string;
}
export interface CardOnFile {
    'description'?: string;
    'PaymentClause': PaymentClauseEnum;
}


export const CardType = {
    american_express: 'american_express',
    dankort: 'dankort',
    diners_club: 'diners_club',
    discover: 'discover',
    jcb: 'jcb',
    maestro: 'maestro',
    master: 'master',
    visa: 'visa'
} as const;

export type CardType = typeof CardType[keyof typeof CardType];


/**
 * The ordered product ID from the cart
 * @export
 * @interface CartOrderedProductId
 */
export interface CartOrderedProductId {
    'productId': string;
}
export interface City {
    'RegionType': RegionTypeEnum;
}


/**
 * Policy result for homes that needs Customer Service action to be canceled

 * `cancelCopy` - Copy to inform the user they need to contact Customer Service.
 * @export
 * @interface ContactCustomerService
 */
export interface ContactCustomerService {
    'cancelCopy': Copy;
    'HomesCancelScenario': HomesCancelScenarioEnum;
}


export interface Coordinates {
    'lat': number;
    'lon': number;
}
/**
 * Copy to be displayed when it is past the check-in date and cancellation is not possible.
 * @export
 * @interface Copy
 */
export interface Copy {
    'importantInfo': Array<string>;
    'body': Array<string>;
    'informativeSection'?: InformativeSection;
    'disclaimer'?: string;
    'callToAction'?: string;
    'title': string;
}
/**
 * `market` - Market ID
 * `listingProviderId` - Listing provider ID
 * `listingId` - Listing ID
 * `stayDates` - Dates for the stay
 * `listingCollection` - Listing Collection (Distribution Channel) of the listing
 * `guests` - Number of each guest type
 * `seenPrice` - The amount the customer has seen for this product.
 * `airportRegion` - Airport region for the listing location
 * @export
 * @interface CreateHomeProductRequest
 */
export interface CreateHomeProductRequest {
    'market'?: Market;
    'listingProviderId': ListingProviderId;
    'listingId': ListingId;
    'stayDates': StayDates;
    'listingCollection': ListingCollection;
    'guests': GuestsSelection;
    'seenPrice': Prices;
    'airportRegion'?: AirportRegion;
}


/**
 * Date range over which to fetch availability
 * @export
 * @interface DateRange
 */
export interface DateRange {
    'from': string;
    'until': string;
}
export interface Direct {
    'SettlementMethod': SettlementMethodEnum;
}


/**
 * `kind` - The kind of the discount
 * `funding` - Whether the discount was funded by the host, Hopper, or jointly
 * @export
 * @interface Discount
 */
export interface Discount {
    'kind': DiscountKind;
    'funding': Funding;
}


export interface DiscountFundedAmounts {
    'amount': number;
    'percentage': number;
}
export const DiscountKind = {
    EarlyBird: 'EarlyBird',
    FirstBookings: 'FirstBookings',
    LastMinute: 'LastMinute',
    LongStay: 'LongStay',
    Monthly: 'Monthly',
    Unrecognized: 'Unrecognized',
    Unspecified: 'Unspecified',
    Weekly: 'Weekly'
} as const;

export type DiscountKind = typeof DiscountKind[keyof typeof DiscountKind];


/**
 * `channelId` - Distribution Channel (Listing Collection), e.g., cap1_lux_premier, cap1_lux_lifestyle, hopper_app
 * @export
 * @interface DistributionChannel
 */
export interface DistributionChannel {
    /**
     * Distribution Channel (Listing Collection), e.g., cap1_lux_premier, cap1_lux_lifestyle, hopper_app
     * @type {string}
     * @memberof DistributionChannel
     */
    'channelId': string;
}
/**
 * `min` - The lower bound of the range.
 * `max` - The upper bound of the range.
 * @export
 * @interface DoubleRange
 */
export interface DoubleRange {
    /**
     * The lower bound of the range.
     * @type {number}
     * @memberof DoubleRange
     */
    'min'?: number;
    /**
     * The upper bound of the range.
     * @type {number}
     * @memberof DoubleRange
     */
    'max'?: number;
}
export interface DriverLicense {
    'country': string;
    'cityCode': string;
    'street': string;
    'postCode': string;
}
export interface Empty {
    'AvailabilityRequest': AvailabilityRequestEnum;
}


export interface ErrorCode {
    'code': string;
    'details'?: string;
}
export interface Exact {
    'Specificity': SpecificityEnum;
}


/**
 * Cancellation failed to start fulfillment
 * @export
 * @interface Failure
 */
export interface Failure {
    'HomesCancelFulfillmentPollResponse': HomesCancelFulfillmentPollResponseEnum;
}


/**
 * `kind` - The type of fee
 * `amount` - The amount of the fee
 * `name` - The name of the fee
 * `description` - The description of the fee
 * @export
 * @interface Fee
 */
export interface Fee {
    'kind': FeeKind;
    'amount': Prices;
    /**
     * The name of the fee
     * @type {string}
     * @memberof Fee
     */
    'name'?: string;
    /**
     * The description of the fee
     * @type {string}
     * @memberof Fee
     */
    'description'?: string;
}


/**
 * 

* `CleaningFee` - Provider-assessed
* `HopperServiceFee` - Hopper-assessed service fee
* `HotelFees` - Provider-assessed
* `PetFee` - Provider-assessed
* `PropertyFee` - Provider-assessed
* `ResortFees` - Provider-assessed
* `TravelerServiceFee` - Provider-assessed
 * @export
 * @enum {string}
 */

export const FeeKind = {
    CleaningFee: 'CleaningFee',
    HopperServiceFee: 'HopperServiceFee',
    HotelFees: 'HotelFees',
    PetFee: 'PetFee',
    PropertyFee: 'PropertyFee',
    ResortFees: 'ResortFees',
    TravelerServiceFee: 'TravelerServiceFee',
    Unrecognized: 'Unrecognized',
    Unspecified: 'Unspecified'
} as const;

export type FeeKind = typeof FeeKind[keyof typeof FeeKind];


/**
 * A cash amount
 * @export
 * @interface FiatPrice
 */
export interface FiatPrice {
    'currencyCode': string;
    'currencySymbol': string;
    'value': number;
}
/**
 * Followup search request

 * `nextPageToken` - Token for the next page of results
 * `stayDetails` - Stay dates and number of guests
 * @export
 * @interface FollowupSearch
 */
export interface FollowupSearch {
    'nextPageToken': SearchPageToken;
    'stayDetails': StayDetails;
    'AvailabilityRequest': AvailabilityRequestEnum;
}


export interface FrequentFlyerNumber {
    'value': string;
}
export interface FullPaymentDueNow {
    'PaymentSchedule': PaymentScheduleEnum;
}


/**
 * Policy result for homes cancellation that results in a full refund

 * `cancelCopy` - Copy to be displayed when the cancellation policy currently allows for a full refund.
 * `cancelConfirmationCopy` - Copy to be displayed when the user is confirming/submitting their cancellation request.
 * @export
 * @interface FullyRefundable
 */
export interface FullyRefundable {
    'cancelCopy': Copy;
    'cancelConfirmationCopy': Copy;
    'HomesCancelScenario': HomesCancelScenarioEnum;
}


export interface FundedAmounts {
    'amount': Prices;
    'percentage': number;
}
/**
 * @type Funding
 * Whether the discount was funded by the host, Hopper, or jointly
 * @export
 */
export type Funding = { Funding: 'Empty' } & FundingEmpty | { Funding: 'HopperFunded' } & FundingHopperFunded | { Funding: 'HostFunded' } & FundingHostFunded | { Funding: 'JointFunded' } & FundingJointFunded;

export interface FundingEmpty {
    'Funding': FundingEnum;
}


export const FundingEnum = {
    Empty: 'Empty',
    HopperFunded: 'HopperFunded',
    HostFunded: 'HostFunded',
    JointFunded: 'JointFunded'
} as const;

export type FundingEnum = typeof FundingEnum[keyof typeof FundingEnum];


export interface FundingHopperFunded {
    'hopperFunded': FundedAmounts;
    'Funding': FundingEnum;
}


export interface FundingHostFunded {
    'hostFunded': FundedAmounts;
    'Funding': FundingEnum;
}


export interface FundingJointFunded {
    'hopperFunded': FundedAmounts;
    'hostFunded': FundedAmounts;
    'Funding': FundingEnum;
}


export const Gender = {
    F: 'F',
    M: 'M'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];


/**
 * `listingId` - Listing ID for which to fetch availability
 * `dateRange` - Date range over which to fetch availability
 * @export
 * @interface GetCalendarAvailabilityRequest
 */
export interface GetCalendarAvailabilityRequest {
    'listingId': ListingId;
    'dateRange': DateRange;
}
/**
 * `calendarDays` - a list of dates and corresponding calendar metadata
 * @export
 * @interface GetCalendarAvailabilityResponse
 */
export interface GetCalendarAvailabilityResponse {
    /**
     * a list of dates and corresponding calendar metadata
     * @type {Array<CalendarDay>}
     * @memberof GetCalendarAvailabilityResponse
     */
    'calendarDays': Array<CalendarDay>;
}
export interface GetHomeReservationRequest {
    'reservationBookingId': string;
}
/**
 * @type GroupedHomesLineItem
 * 
 * @export
 */
export type GroupedHomesLineItem = { GroupedHomesLineItem: 'CleaningFees' } & GroupedHomesLineItemCleaningFees | { GroupedHomesLineItem: 'HostAndManagementFees' } & GroupedHomesLineItemHostAndManagementFees | { GroupedHomesLineItem: 'Taxes' } & GroupedHomesLineItemTaxes | { GroupedHomesLineItem: 'VacationRental' } & GroupedHomesLineItemVacationRental;

export interface GroupedHomesLineItemCleaningFees {
    'displayName': string;
    'description'?: string;
    'total': Prices;
    'GroupedHomesLineItem': GroupedHomesLineItemEnum;
    'fees': Array<HomesFee>;
}


export const GroupedHomesLineItemEnum = {
    CleaningFees: 'CleaningFees',
    HostAndManagementFees: 'HostAndManagementFees',
    Taxes: 'Taxes',
    VacationRental: 'VacationRental'
} as const;

export type GroupedHomesLineItemEnum = typeof GroupedHomesLineItemEnum[keyof typeof GroupedHomesLineItemEnum];


export interface GroupedHomesLineItemHostAndManagementFees {
    'displayName': string;
    'description'?: string;
    'total': Prices;
    'GroupedHomesLineItem': GroupedHomesLineItemEnum;
    'fees': Array<HomesFee>;
}


export interface GroupedHomesLineItemTaxes {
    'displayName': string;
    'description'?: string;
    'total': Prices;
    'GroupedHomesLineItem': GroupedHomesLineItemEnum;
    'fees': Array<HomesFee>;
}


export interface GroupedHomesLineItemVacationRental {
    'displayName': string;
    'description'?: string;
    'total': Prices;
    'GroupedHomesLineItem': GroupedHomesLineItemEnum;
    'fees': Array<HomesFee>;
}


export interface Guest {
    'Instigator': InstigatorEnum;
}


/**
 * Number of each guest type
 * @export
 * @interface GuestsSelection
 */
export interface GuestsSelection {
    'adults': number;
    'children': number;
    'infants': number;
    'petsIncluded': boolean;
}
export interface HomeItineraryRequest {
    'states': Array<HomeItineraryState>;
    'referenceDateTime': string;
}
export interface HomeItineraryResponse {
    'itineraries': { [key: string]: Array<HomesReservation>; };
}
export const HomeItineraryState = {
    Canceled: 'Canceled',
    Future: 'Future',
    Past: 'Past',
    Present: 'Present'
} as const;

export type HomeItineraryState = typeof HomeItineraryState[keyof typeof HomeItineraryState];


export interface HomeLocation {
    'specificity': Specificity;
    'coordinates': Coordinates;
}
export interface HomesAmenity {
    'kind': AmenityKind;
    'displayName': string;
}


/**
 * Failed response to an agent fulfillment request.
 * @export
 * @interface HomesCancelAgentFulfillFailure
 */
export interface HomesCancelAgentFulfillFailure {
    'HomesCancelAgentFulfillResponse': HomesCancelAgentFulfillResponseEnum;
}


/**
 * `customerReservationId` - Unique human-readable reservation id that identifies the homes reservation, e.g., D6VLZTG2GKZG
 * @export
 * @interface HomesCancelAgentFulfillRequest
 */
export interface HomesCancelAgentFulfillRequest {
    /**
     * Unique human-readable reservation id that identifies the homes reservation, e.g., D6VLZTG2GKZG
     * @type {string}
     * @memberof HomesCancelAgentFulfillRequest
     */
    'customerReservationId': string;
}
/**
 * @type HomesCancelAgentFulfillResponse
 * @export
 */
export type HomesCancelAgentFulfillResponse = { HomesCancelAgentFulfillResponse: 'HomesCancelAgentFulfillFailure' } & HomesCancelAgentFulfillFailure | { HomesCancelAgentFulfillResponse: 'HomesCancelAgentFulfillSuccess' } & HomesCancelAgentFulfillSuccess;

export const HomesCancelAgentFulfillResponseEnum = {
    HomesCancelAgentFulfillFailure: 'HomesCancelAgentFulfillFailure',
    HomesCancelAgentFulfillSuccess: 'HomesCancelAgentFulfillSuccess'
} as const;

export type HomesCancelAgentFulfillResponseEnum = typeof HomesCancelAgentFulfillResponseEnum[keyof typeof HomesCancelAgentFulfillResponseEnum];


/**
 * Response to an agent fulfillment request. Contains the identifier used to poll the status of the fulfillment session.
 * @export
 * @interface HomesCancelAgentFulfillSuccess
 */
export interface HomesCancelAgentFulfillSuccess {
    'HomesCancelAgentFulfillResponse': HomesCancelAgentFulfillResponseEnum;
}


/**
 * Failed response to a fulfillment request.
 * @export
 * @interface HomesCancelFulfillFailure
 */
export interface HomesCancelFulfillFailure {
    'HomesCancelFulfillResponse': HomesCancelFulfillResponseEnum;
}


/**
 * Request that starts the fulfillment of a homes cancel. Non-idempotent, it creates state by starting a cart fulfillment session.
 * @export
 * @interface HomesCancelFulfillRequest
 */
export interface HomesCancelFulfillRequest {
    'quoteId': string;
}
/**
 * @type HomesCancelFulfillResponse
 * @export
 */
export type HomesCancelFulfillResponse = { HomesCancelFulfillResponse: 'HomesCancelFulfillFailure' } & HomesCancelFulfillFailure | { HomesCancelFulfillResponse: 'HomesCancelFulfillSuccess' } & HomesCancelFulfillSuccess;

export const HomesCancelFulfillResponseEnum = {
    HomesCancelFulfillFailure: 'HomesCancelFulfillFailure',
    HomesCancelFulfillSuccess: 'HomesCancelFulfillSuccess'
} as const;

export type HomesCancelFulfillResponseEnum = typeof HomesCancelFulfillResponseEnum[keyof typeof HomesCancelFulfillResponseEnum];


/**
 * Response to a fulfillment request. Contains the identifier used to poll the status of the fulfillment session.

 * `fulfillmentSessionId` - Encrypted fulfillment session id. Used in the HomesCancelFulfillmentPollRequest to poll the status of the fulfillment.
 * @export
 * @interface HomesCancelFulfillSuccess
 */
export interface HomesCancelFulfillSuccess {
    /**
     * Encrypted fulfillment session id. Used in the HomesCancelFulfillmentPollRequest to poll the status of the fulfillment.
     * @type {string}
     * @memberof HomesCancelFulfillSuccess
     */
    'fulfillmentSessionId': string;
    'HomesCancelFulfillResponse': HomesCancelFulfillResponseEnum;
}


/**
 * Request for the status of the fulfillment session in progress. This is an idempotent call and just fetches the state of the session.

 * `fulfillmentSessionId` - Encrypted fulfillment session id.
 * @export
 * @interface HomesCancelFulfillmentPollRequest
 */
export interface HomesCancelFulfillmentPollRequest {
    /**
     * Encrypted fulfillment session id.
     * @type {string}
     * @memberof HomesCancelFulfillmentPollRequest
     */
    'fulfillmentSessionId': string;
}
/**
 * @type HomesCancelFulfillmentPollResponse
 * Fulfillment session status. Can be Pending, Success or Failure.
 * @export
 */
export type HomesCancelFulfillmentPollResponse = { HomesCancelFulfillmentPollResponse: 'Aborted' } & Aborted | { HomesCancelFulfillmentPollResponse: 'Failure' } & Failure | { HomesCancelFulfillmentPollResponse: 'Pending' } & Pending | { HomesCancelFulfillmentPollResponse: 'Success' } & Success;

export const HomesCancelFulfillmentPollResponseEnum = {
    Aborted: 'Aborted',
    Failure: 'Failure',
    Pending: 'Pending',
    Success: 'Success'
} as const;

export type HomesCancelFulfillmentPollResponseEnum = typeof HomesCancelFulfillmentPollResponseEnum[keyof typeof HomesCancelFulfillmentPollResponseEnum];


/**
 * Failed Homes cancel quote response
 * @export
 * @interface HomesCancelQuoteFailure
 */
export interface HomesCancelQuoteFailure {
    'HomesCancelQuoteResponse': HomesCancelQuoteResponseEnum;
}


/**
 * Request that start a Homes Cancel Quote. This is an idempotent request.

 * `customerReservationId` - Unique human-readable reservation id that identifies the homes reservation.
 * @export
 * @interface HomesCancelQuoteRequest
 */
export interface HomesCancelQuoteRequest {
    /**
     * Unique human-readable reservation id that identifies the homes reservation.
     * @type {string}
     * @memberof HomesCancelQuoteRequest
     */
    'customerReservationId': string;
}
/**
 * @type HomesCancelQuoteResponse
 * @export
 */
export type HomesCancelQuoteResponse = { HomesCancelQuoteResponse: 'HomesCancelQuoteFailure' } & HomesCancelQuoteFailure | { HomesCancelQuoteResponse: 'HomesCancelQuoteSuccess' } & HomesCancelQuoteSuccess;

export const HomesCancelQuoteResponseEnum = {
    HomesCancelQuoteFailure: 'HomesCancelQuoteFailure',
    HomesCancelQuoteSuccess: 'HomesCancelQuoteSuccess'
} as const;

export type HomesCancelQuoteResponseEnum = typeof HomesCancelQuoteResponseEnum[keyof typeof HomesCancelQuoteResponseEnum];


/**
 * Cancel quote response with the fare rule result and quote identifier.

 * `cancelScenario` - Policy that would result for this homes if cancellation proceeds.
 * `quoteId` - The encrypted quote identifier, used in HomesCancelFulfillRequest to fulfill the cancellation.
 * @export
 * @interface HomesCancelQuoteSuccess
 */
export interface HomesCancelQuoteSuccess {
    'cancelScenario': HomesCancelScenario;
    /**
     * The encrypted quote identifier, used in HomesCancelFulfillRequest to fulfill the cancellation.
     * @type {string}
     * @memberof HomesCancelQuoteSuccess
     */
    'quoteId'?: string;
    'HomesCancelQuoteResponse': HomesCancelQuoteResponseEnum;
}


/**
 * @type HomesCancelScenario
 * response to homes cancellation and change policy requests
 * @export
 */
export type HomesCancelScenario = { HomesCancelScenario: 'AgentReviewAndFulfillment' } & AgentReviewAndFulfillment | { HomesCancelScenario: 'Canceled' } & Canceled | { HomesCancelScenario: 'ContactCustomerService' } & ContactCustomerService | { HomesCancelScenario: 'FullyRefundable' } & FullyRefundable | { HomesCancelScenario: 'NonRefundable' } & NonRefundable | { HomesCancelScenario: 'PartiallyRefundable' } & PartiallyRefundable | { HomesCancelScenario: 'PastCheckInDate' } & PastCheckInDate;

export const HomesCancelScenarioEnum = {
    AgentReviewAndFulfillment: 'AgentReviewAndFulfillment',
    Canceled: 'Canceled',
    ContactCustomerService: 'ContactCustomerService',
    FullyRefundable: 'FullyRefundable',
    NonRefundable: 'NonRefundable',
    PartiallyRefundable: 'PartiallyRefundable',
    PastCheckInDate: 'PastCheckInDate'
} as const;

export type HomesCancelScenarioEnum = typeof HomesCancelScenarioEnum[keyof typeof HomesCancelScenarioEnum];


/**
 * Failed Homes change quote response
 * @export
 * @interface HomesChangeQuoteFailure
 */
export interface HomesChangeQuoteFailure {
    'HomesChangeQuoteResponse': HomesChangeQuoteResponseEnum;
}


/**
 * Request that start a Homes Change Quote. This is an idempotent request.

 * `customerReservationId` - Unique human-readable reservation id that identifies the homes reservation.
 * @export
 * @interface HomesChangeQuoteRequest
 */
export interface HomesChangeQuoteRequest {
    /**
     * Unique human-readable reservation id that identifies the homes reservation.
     * @type {string}
     * @memberof HomesChangeQuoteRequest
     */
    'customerReservationId': string;
}
/**
 * @type HomesChangeQuoteResponse
 * @export
 */
export type HomesChangeQuoteResponse = { HomesChangeQuoteResponse: 'HomesChangeQuoteFailure' } & HomesChangeQuoteFailure | { HomesChangeQuoteResponse: 'HomesChangeQuoteSuccess' } & HomesChangeQuoteSuccess;

export const HomesChangeQuoteResponseEnum = {
    HomesChangeQuoteFailure: 'HomesChangeQuoteFailure',
    HomesChangeQuoteSuccess: 'HomesChangeQuoteSuccess'
} as const;

export type HomesChangeQuoteResponseEnum = typeof HomesChangeQuoteResponseEnum[keyof typeof HomesChangeQuoteResponseEnum];


/**
 * Cancel quote response with the fare rule result and quote identifier.

 * `cancelScenario` - Policy that would result for this homes if cancellation proceeds.
 * `quoteId` - The encrypted quote identifier, used in HomesCancelFulfillRequest to fulfill the cancellation.
 * `changeCopy` - The copy to display to the user for the homes change scenario.
 * @export
 * @interface HomesChangeQuoteSuccess
 */
export interface HomesChangeQuoteSuccess {
    'cancelScenario': HomesCancelScenario;
    /**
     * The encrypted quote identifier, used in HomesCancelFulfillRequest to fulfill the cancellation.
     * @type {string}
     * @memberof HomesChangeQuoteSuccess
     */
    'quoteId'?: string;
    'changeCopy': Copy;
    'HomesChangeQuoteResponse': HomesChangeQuoteResponseEnum;
}


export interface HomesFee {
    'kind': Kind;
    'amount': Prices;
    'name'?: string;
    'description'?: string;
}
export interface HomesPrice {
    'sellPrice': Prices;
    'totalTaxesAndFees'?: HomesFee;
    'settlementAmounts': HomesSettlementAmounts;
    'includedDiscounts': Array<ReservationDiscount>;
    'fees': Array<HomesFee>;
    'groupedItems': Array<GroupedHomesLineItem>;
    'payNowTotal': Prices;
}
/**
 * `rate` - Price quote for the stay
 * `market` - Market ID
 * `stayDates` - Dates and guests for the stay
 * `listingCollection` - Listing Collection (Distribution Channel) of the listing
 * `listing` - Listing summary, including details, location, policies, etc.
 * `orderedProductId` - The ordered product ID from the cart
 * `airportRegion` - Airport region for the listing location
 * @export
 * @interface HomesPriceQuote
 */
export interface HomesPriceQuote {
    'rate': HomesPublicRate;
    /**
     * Market ID
     * @type {string}
     * @memberof HomesPriceQuote
     */
    'market'?: string;
    'stayDates': StayDates;
    'listingCollection': ListingCollection;
    'listing': ListingSummary;
    'orderedProductId'?: CartOrderedProductId;
    'airportRegion'?: AirportRegion;
}


/**
 * Price quote for the stay
 * @export
 * @interface HomesPublicRate
 */
export interface HomesPublicRate {
    'detailedPrice': HomesPrice;
    'cancellationPolicy'?: CancellationPolicy;
    'paymentPolicy': PaymentPolicy;
    'trackingProperties': TrackingProperties;
    'merchantPointOfSale'?: string;
    'supportedSettlementMethods': Array<SettlementMethod>;
    'policies': Array<RatePolicy>;
}
export interface HomesReservation {
    'rate': HomesPublicRate;
    'lengthOfStay': number;
    'providerBookingReferenceToken'?: string;
    'cancellationPolicy': CancellationPolicyForFE;
    'listingProviderId': ListingProviderId;
    'earnAmountUsd'?: number;
    'guestsSelection': GuestsSelection;
    'orderId'?: string;
    'stayDates': StayDates;
    'listingCollection': ListingCollection;
    'providerAdditionalReservationInfo': { [key: string]: string; };
    'trackingProperties': TrackingProperties;
    'listing': ListingSummary;
    'primaryGuest': Person;
    'cartOrderedProductId': string;
    'id': HomesReservationId;
    'providerConfirmationId': string;
    'status': ReservationStatus;
    'hostInfo'?: HostContactInfo;
    'createdAt': string;
    'transactions': Array<Transaction>;
}


export interface HomesReservationId {
    'value': string;
}
export interface HomesSettlementAmounts {
    'guestServiceFee'?: Prices;
    'providerBasePrice': Prices;
    'commission'?: Prices;
    'markup'?: Prices;
    'commissionCashBack'?: Prices;
    'guestServiceFeeCashBack'?: Prices;
    'hostServiceFee'?: Prices;
    'hostServiceFeeCashBack'?: Prices;
}
/**
 * `percentage` - Percentage discount amount for percentage offer
 * `shopPageBanner` - Banner string for shop page if present
 * `funnels` - Offer funnel/vertical
 * `amount` - Discount amount in USD
 * `expiresOn` - Offer expiration datetime
 * `availabilityPageBanner` - Banner string for availability page if present
 * `imageId` - Image name that's set in the offer config
 * `trackingPropertiesV2` - Offer tracking properties
 * `termsAndConditions` - Terms and Conditions for the offer
 * `title` - Offer Title
 * `landingPageBanner` - Banner string for landing page if present
 * `maxDiscountAmount` - Max discount amount in USD for percentage offer
 * `descriptions` - Offer Description list
 * @export
 * @interface HomesTravelWalletOffer
 */
export interface HomesTravelWalletOffer {
    /**
     * Percentage discount amount for percentage offer
     * @type {number}
     * @memberof HomesTravelWalletOffer
     */
    'percentage'?: number;
    /**
     * Banner string for shop page if present
     * @type {string}
     * @memberof HomesTravelWalletOffer
     */
    'shopPageBanner'?: string;
    /**
     * Offer funnel/vertical
     * @type {Array<HomesTravelWalletOfferFunnel>}
     * @memberof HomesTravelWalletOffer
     */
    'funnels': Array<HomesTravelWalletOfferFunnel>;
    'amount': Amount;
    /**
     * Offer expiration datetime
     * @type {string}
     * @memberof HomesTravelWalletOffer
     */
    'expiresOn': string;
    /**
     * Banner string for availability page if present
     * @type {string}
     * @memberof HomesTravelWalletOffer
     */
    'availabilityPageBanner'?: string;
    'id': string;
    /**
     * Image name that's set in the offer config
     * @type {string}
     * @memberof HomesTravelWalletOffer
     */
    'imageId'?: string;
    'trackingPropertiesV2': TrackingProperties;
    /**
     * Terms and Conditions for the offer
     * @type {string}
     * @memberof HomesTravelWalletOffer
     */
    'termsAndConditions'?: string;
    /**
     * Offer Title
     * @type {string}
     * @memberof HomesTravelWalletOffer
     */
    'title': string;
    /**
     * Banner string for landing page if present
     * @type {string}
     * @memberof HomesTravelWalletOffer
     */
    'landingPageBanner'?: string;
    'maxDiscountAmount'?: Amount;
    /**
     * Offer Description list
     * @type {Array<string>}
     * @memberof HomesTravelWalletOffer
     */
    'descriptions': Array<string>;
}
export const HomesTravelWalletOfferFunnel = {
    Air: 'Air',
    Ground: 'Ground',
    Homes: 'Homes',
    Lodging: 'Lodging'
} as const;

export type HomesTravelWalletOfferFunnel = typeof HomesTravelWalletOfferFunnel[keyof typeof HomesTravelWalletOfferFunnel];


/**
 * Homes user rating value should be within range [0.0, 100.0]
 * @export
 * @interface HomesUserRating
 */
export interface HomesUserRating {
    /**
     * normalized rating value should be within range [0, 1]
     * @type {number}
     * @memberof HomesUserRating
     */
    'score': number;
    /**
     * Number of user reviews for the property.
     * @type {number}
     * @memberof HomesUserRating
     */
    'numberOfReviews': number;
}
/**
 * `bestOfferOverall` - Best offer out of all offers for returned lodgings if exists
 * `offersByProductId` - ListingId (ProductId) mapped to the corresponding best offer for the shopped home product
 * `opaqueProductMap` - ListingId mapped to encrypted wallet model the FE passes back to the wallet /applicable endpoint to receive all wallet offers after a base product is chosen. This exists in lodging as there is no support for refetching a shopped hotel trip via API for external services
 * @export
 * @interface HomesWalletOfferApplicabilityResponse
 */
export interface HomesWalletOfferApplicabilityResponse {
    'bestOfferOverall'?: HomesTravelWalletOffer;
    /**
     * ListingId (ProductId) mapped to the corresponding best offer for the shopped home product
     * @type {{ [key: string]: HomesTravelWalletOffer; }}
     * @memberof HomesWalletOfferApplicabilityResponse
     */
    'offersByProductId': { [key: string]: HomesTravelWalletOffer; };
    /**
     * ListingId mapped to encrypted wallet model the FE passes back to the wallet /applicable endpoint to receive all wallet offers after a base product is chosen. This exists in lodging as there is no support for refetching a shopped hotel trip via API for external services
     * @type {{ [key: string]: string; }}
     * @memberof HomesWalletOfferApplicabilityResponse
     */
    'opaqueProductMap': { [key: string]: string; };
}
export interface Host {
    'Instigator': InstigatorEnum;
}


export interface HostContact {
    'type': HostContactType;
    'name'?: string;
    'phoneNumber'?: string;
    'email'?: string;
}


export interface HostContactInfo {
    'hostId': HostId;
    'name': string;
    'contacts': Array<HostContact>;
}
export const HostContactType = {
    Emergency: 'Emergency',
    Primary: 'Primary'
} as const;

export type HostContactType = typeof HostContactType[keyof typeof HostContactType];


export interface HostId {
    'value': string;
}
/**
 * Host information for the listing.
 * @export
 * @interface HostInfo
 */
export interface HostInfo {
    'hostName'?: string;
    'hostImageUrl'?: string;
    'hostLanguages': Array<string>;
    'hostDescription'?: string;
}
export interface HotelLoyaltyNumber {
    'value': string;
}
export interface InformativeSection {
    'title': string;
    'body': Array<string>;
}
/**
 * Initial search request

 * `availabilityMode` - Controls whether to return listings that are available, unavailable, or both.
 * `listingSelection` - Search for listings by place id or listing ids
 * `stayDetails` - Stay dates and number of guests
 * `distributionChannels` - Distribution Channels (Listing Collections) to include in search results
 * `searchFilters` - Search filters for number of bedrooms, bathrooms, etc.
 * @export
 * @interface InitialSearch
 */
export interface InitialSearch {
    'availabilityMode': AvailabilityMode;
    'listingSelection': ListingSelection;
    'stayDetails': StayDetails;
    /**
     * Distribution Channels (Listing Collections) to include in search results
     * @type {Array<DistributionChannel>}
     * @memberof InitialSearch
     */
    'distributionChannels': Array<DistributionChannel>;
    'searchFilters'?: SearchFilters;
    'AvailabilityRequest': AvailabilityRequestEnum;
}


/**
 * @type Instigator
 * @export
 */
export type Instigator = { Instigator: 'Guest' } & Guest | { Instigator: 'Host' } & Host;

export const InstigatorEnum = {
    Guest: 'Guest',
    Host: 'Host'
} as const;

export type InstigatorEnum = typeof InstigatorEnum[keyof typeof InstigatorEnum];


export interface InterpolatedUserCard {
    'cvvRequired': boolean;
    'acceptedCreditCard': AcceptedCreditCard;
    'SettlementMethod': SettlementMethodEnum;
}


/**
 * @type Kind
 * @export
 */
export type Kind = { Kind: 'CityTax' } & KindCityTax | { Kind: 'CleaningFee' } & KindCleaningFee | { Kind: 'Fee' } & KindFee | { Kind: 'HopperServiceFee' } & KindHopperServiceFee | { Kind: 'HotelFee' } & KindHotelFee | { Kind: 'OccupancyFee' } & KindOccupancyFee | { Kind: 'PetFee' } & KindPetFee | { Kind: 'PropertyFee' } & KindPropertyFee | { Kind: 'RecoveryChargesTax' } & KindRecoveryChargesTax | { Kind: 'ResortFee' } & KindResortFee | { Kind: 'SalesTax' } & KindSalesTax | { Kind: 'Tax' } & KindTax | { Kind: 'TotalTaxesAndFees' } & KindTotalTaxesAndFees | { Kind: 'TravelerServiceFee' } & KindTravelerServiceFee;

export interface KindCityTax {
    'Kind': KindEnum;
}


export interface KindCleaningFee {
    'Kind': KindEnum;
}


export const KindEnum = {
    CityTax: 'CityTax',
    CleaningFee: 'CleaningFee',
    Fee: 'Fee',
    HopperServiceFee: 'HopperServiceFee',
    HotelFee: 'HotelFee',
    OccupancyFee: 'OccupancyFee',
    PetFee: 'PetFee',
    PropertyFee: 'PropertyFee',
    RecoveryChargesTax: 'RecoveryChargesTax',
    ResortFee: 'ResortFee',
    SalesTax: 'SalesTax',
    Tax: 'Tax',
    TotalTaxesAndFees: 'TotalTaxesAndFees',
    TravelerServiceFee: 'TravelerServiceFee'
} as const;

export type KindEnum = typeof KindEnum[keyof typeof KindEnum];


export interface KindFee {
    'Kind': KindEnum;
}


export interface KindHopperServiceFee {
    'Kind': KindEnum;
}


export interface KindHotelFee {
    'Kind': KindEnum;
}


export interface KindOccupancyFee {
    'Kind': KindEnum;
}


export interface KindPetFee {
    'Kind': KindEnum;
}


export interface KindPropertyFee {
    'Kind': KindEnum;
}


export interface KindRecoveryChargesTax {
    'Kind': KindEnum;
}


export interface KindResortFee {
    'Kind': KindEnum;
}


export interface KindSalesTax {
    'Kind': KindEnum;
}


export interface KindTax {
    'Kind': KindEnum;
}


export interface KindTotalTaxesAndFees {
    'Kind': KindEnum;
}


export interface KindTravelerServiceFee {
    'Kind': KindEnum;
}


/**
 * `providerData` - Provider data for the listing.
 * `listingCollection` - Listing Collection (Distribution Channel) of the listing
 * `id` - Unique identifier for the listing. UUID
 * `privateHostInfo` - Private host information for the listing.
 * `hostInfo` - Host information for the listing.
 * `content` - Name, description, media, amenities, layout, location, etc. of the property.
 * `terms` - Terms of the listing, including check-in/out times, max occupancy, etc.
 * @export
 * @interface Listing
 */
export interface Listing {
    'providerData': ListingProviderData;
    'listingCollection': ListingCollection;
    'trackingProperties': TrackingProperties;
    'id': ListingId;
    'privateHostInfo'?: PrivateHostInfo;
    'hostInfo'?: HostInfo;
    'content': ListingContent;
    'terms': ListingTerms;
}


/**
 * @type ListingAddress
 * @export
 */
export type ListingAddress = { ListingAddress: 'Empty' } & ListingAddressEmpty | { ListingAddress: 'ObfuscatedAddress' } & ListingAddressObfuscatedAddress;

export interface ListingAddressEmpty {
    'ListingAddress': ListingAddressEnum;
}


export const ListingAddressEnum = {
    Empty: 'Empty',
    ObfuscatedAddress: 'ObfuscatedAddress'
} as const;

export type ListingAddressEnum = typeof ListingAddressEnum[keyof typeof ListingAddressEnum];


export interface ListingAddressObfuscatedAddress {
    'city'?: string;
    'state'?: string;
    'postalCode'?: string;
    'countryCode'?: string;
    'ListingAddress': ListingAddressEnum;
}


export const ListingCollection = {
    Lifestyle: 'Lifestyle',
    NoCollection: 'NoCollection',
    Premier: 'Premier'
} as const;

export type ListingCollection = typeof ListingCollection[keyof typeof ListingCollection];


/**
 * `name` - Name of the property
 * `location` - Coordinates and address of the property.
 * `description` - Description of the property
 * `registrationId` - Registration ID for the property, if any.
 * `amenities` - Amenities for the property, such as wifi, pool, etc.
 * `starRating` - Star rating of the property.
 * `userRating` - User rating of the property.
 * `media` - Media assets for the property, such as photos.
 * `layout` - Layout of the property, such as number of bedrooms, bathrooms, etc.
 * @export
 * @interface ListingContent
 */
export interface ListingContent {
    /**
     * Name of the property
     * @type {string}
     * @memberof ListingContent
     */
    'name': string;
    'location': ListingLocation;
    /**
     * Description of the property
     * @type {string}
     * @memberof ListingContent
     */
    'description': string;
    /**
     * Registration ID for the property, if any.
     * @type {string}
     * @memberof ListingContent
     */
    'registrationId'?: string;
    /**
     * Amenities for the property, such as wifi, pool, etc.
     * @type {Array<HomesAmenity>}
     * @memberof ListingContent
     */
    'amenities': Array<HomesAmenity>;
    /**
     * Star rating of the property.
     * @type {number}
     * @memberof ListingContent
     */
    'starRating'?: number;
    'userRating'?: HomesUserRating;
    /**
     * Media assets for the property, such as photos.
     * @type {Array<MediaAsset>}
     * @memberof ListingContent
     */
    'media': Array<MediaAsset>;
    'layout': ListingLayout;
}
/**
 * Listing ID
 * @export
 * @interface ListingId
 */
export interface ListingId {
    'id': string;
}
/**
 * Layout of the property, such as number of bedrooms, bathrooms, etc.
 * @export
 * @interface ListingLayout
 */
export interface ListingLayout {
    'bedrooms': Array<Bedroom>;
    'numberOfBathrooms': number;
    'numberOfBedrooms': number;
    'bathrooms': Array<Bathroom>;
    'numberOfBeds': number;
}
/**
 * Coordinates and address of the property.
 * @export
 * @interface ListingLocation
 */
export interface ListingLocation {
    'obfuscationRequired': boolean;
    'exactCoordinates': Coordinates;
    'address': ListingAddress;
}
/**
 * Provider data for the listing.
 * @export
 * @interface ListingProviderData
 */
export interface ListingProviderData {
    'listingProviderId': ListingProviderId;
    'providerCategory': ProviderCategory;
}


/**
 * Collection of identifiers for a listing in the external systems Homes is integrated with.
 * @export
 * @interface ListingProviderId
 */
export interface ListingProviderId {
    'provider': string;
    'propertyId': string;
    'unitId': string;
    'partnerExternalId'?: string;
}
/**
 * `listingId` - Unique identifier for the listing. UUID
 * `listing` - Home Listing with details about the listing
 * `availability` - Whether the listing is available or unavailable for the given search criteria
 * `bestOffer` - Best HomesWalletOffer for this listing
 * @export
 * @interface ListingSearchResult
 */
export interface ListingSearchResult {
    'listingId': ListingId;
    'listing': Listing;
    'availability': AvailabilityResult;
    'bestOffer'?: HomesTravelWalletOffer;
}
/**
 * Place ID or listing IDs to search for
 * @export
 * @interface ListingSelection
 */
export interface ListingSelection {
    'selection': Selection;
}
/**
 * Listing summary, including details, location, policies, etc.
 * @export
 * @interface ListingSummary
 */
export interface ListingSummary {
    'areaName': string;
    'name': string;
    'importantInformation'?: string;
    'rentalPolicyUrl'?: string;
    'location'?: HomeLocation;
    'market'?: Market;
    'checkOutTimes'?: TimeRange;
    'state'?: string;
    'listingId': ListingId;
    'timezone'?: string;
    'registrationId'?: string;
    'maxGuests': number;
    'checkInTimes'?: TimeRange;
    'petFriendly': boolean;
    'checkinInformation'?: string;
    'apartment'?: string;
    'coverImage': string;
    'petsPolicy'?: string;
    'postalCode'?: string;
    'starRating'?: number;
    'countryCode'?: string;
    'hostId'?: HostId;
    'address': string;
    'about'?: string;
    'numberOfBeds'?: number;
}
/**
 * Terms of the listing, including check-in/out times, max occupancy, etc.
 * @export
 * @interface ListingTerms
 */
export interface ListingTerms {
    'importantInformation'?: string;
    'checkOutTimes'?: TimeRange;
    'checkInTimes'?: TimeRange;
    'petFriendly'?: boolean;
    'checkinInformation'?: string;
    'petsPolicy'?: string;
    'maxOccupancy': number;
}
/**
 * Market ID
 * @export
 * @interface Market
 */
export interface Market {
    'id': string;
    'name': string;
    'partitionDate': string;
}
export interface MediaAsset {
    'kind': MediaAssetKind;
    'url': string;
    'description'?: string;
}


export const MediaAssetKind = {
    Image: 'Image',
    Unrecognized: 'Unrecognized',
    Unspecified: 'Unspecified'
} as const;

export type MediaAssetKind = typeof MediaAssetKind[keyof typeof MediaAssetKind];


export interface Nationality {
    'country': string;
}
/**
 * Policy result for homes cancellation that is non-refundable

 * `cancelCopy` - Copy to be displayed when booking is non-refundable.
 * @export
 * @interface NonRefundable
 */
export interface NonRefundable {
    'cancelCopy': Copy;
    'HomesCancelScenario': HomesCancelScenarioEnum;
}


/**
 * Policy result for homes cancellation that results in a partial refund

 * `cancelCopy` - Copy to be displayed when the cancellation policy currently allows for a partial refund.
 * `cancelConfirmationCopy` - Copy to be displayed when the user is confirming/submitting their cancellation request.This is optional since the penalty on a partial refund could exceed the available refund amount.
 * `refundAmount` - Amount to be refunded to the user after deducting the cancellation penalty.
 * @export
 * @interface PartiallyRefundable
 */
export interface PartiallyRefundable {
    'cancelCopy': Copy;
    'cancelConfirmationCopy'?: Copy;
    /**
     * Amount to be refunded to the user after deducting the cancellation penalty.
     * @type {string}
     * @memberof PartiallyRefundable
     */
    'refundAmount': string;
    'HomesCancelScenario': HomesCancelScenarioEnum;
}


export interface Passport {
    'countryOfIssue': string;
    'number': string;
    'expiration': string;
}
/**
 * Policy result for homes that are past the check-in date.

 * `cancelCopy` - Copy to be displayed when it is past the check-in date and cancellation is not possible.
 * @export
 * @interface PastCheckInDate
 */
export interface PastCheckInDate {
    'cancelCopy': Copy;
    'HomesCancelScenario': HomesCancelScenarioEnum;
}


/**
 * @type PaymentClause
 * @export
 */
export type PaymentClause = { PaymentClause: 'CardOnFile' } & CardOnFile | { PaymentClause: 'Text' } & Text;

export const PaymentClauseEnum = {
    CardOnFile: 'CardOnFile',
    Text: 'Text'
} as const;

export type PaymentClauseEnum = typeof PaymentClauseEnum[keyof typeof PaymentClauseEnum];


export interface PaymentPolicy {
    'schedule': PaymentSchedule;
    'clauses': Array<PaymentClause>;
}
/**
 * @type PaymentSchedule
 * @export
 */
export type PaymentSchedule = { PaymentSchedule: 'FullPaymentDueNow' } & FullPaymentDueNow | { PaymentSchedule: 'PaymentText' } & PaymentText | { PaymentSchedule: 'UnspecifiedPaymentSchedule' } & UnspecifiedPaymentSchedule;

export const PaymentScheduleEnum = {
    FullPaymentDueNow: 'FullPaymentDueNow',
    PaymentText: 'PaymentText',
    UnspecifiedPaymentSchedule: 'UnspecifiedPaymentSchedule'
} as const;

export type PaymentScheduleEnum = typeof PaymentScheduleEnum[keyof typeof PaymentScheduleEnum];


export interface PaymentText {
    'text': string;
    'PaymentSchedule': PaymentScheduleEnum;
}


/**
 * @type Penalty
 * @export
 */
export type Penalty = { Penalty: 'Empty' } & PenaltyEmpty | { Penalty: 'FlatFee' } & PenaltyFlatFee | { Penalty: 'NumberOfNights' } & PenaltyNumberOfNights | { Penalty: 'PercentageTotal' } & PenaltyPercentageTotal;

export interface PenaltyEmpty {
    'Penalty': PenaltyEnum;
}


export const PenaltyEnum = {
    Empty: 'Empty',
    FlatFee: 'FlatFee',
    NumberOfNights: 'NumberOfNights',
    PercentageTotal: 'PercentageTotal'
} as const;

export type PenaltyEnum = typeof PenaltyEnum[keyof typeof PenaltyEnum];


export interface PenaltyFlatFee {
    'fee': number;
    'Penalty': PenaltyEnum;
}


export interface PenaltyNumberOfNights {
    'nights': number;
    'Penalty': PenaltyEnum;
}


export interface PenaltyPercentageTotal {
    'percentage': number;
    'Penalty': PenaltyEnum;
}


/**
 * Cancellation fulfillment is still in progress
 * @export
 * @interface Pending
 */
export interface Pending {
    'HomesCancelFulfillmentPollResponse': HomesCancelFulfillmentPollResponseEnum;
}


export interface Person {
    'givenName': string;
    'knownTravelerNumber'?: string;
    'phoneNumber'?: string;
    'middleName'?: string;
    'emailAddress'?: string;
    'driverLicense'?: DriverLicense;
    'surname': string;
    'dateOfBirth': string;
    'passport'?: Passport;
    'id': string;
    'redressNumberIssuingCountry'?: string;
    'frequentFlyer': { [key: string]: FrequentFlyerNumber; };
    'hotelLoyalty': { [key: string]: HotelLoyaltyNumber; };
    'redressNumber'?: string;
    'nationality'?: Nationality;
    'createdAt': string;
    'assistance': Array<Assistance>;
    'knownTravelerNumberIssuingCountry'?: string;
    'lastBookedWith'?: string;
    'gender': Gender;
}


/**
 * @type Policy
 * @export
 */
export type Policy = { Policy: 'CancellationSchedule' } & PolicyCancellationSchedule | { Policy: 'Empty' } & PolicyEmpty | { Policy: 'NonRefundable' } & PolicyNonRefundable;

export interface PolicyCancellationSchedule {
    'steps': Array<CancellationScheduleStep>;
    'Policy': PolicyEnum;
}


export interface PolicyEmpty {
    'Policy': PolicyEnum;
}


export const PolicyEnum = {
    CancellationSchedule: 'CancellationSchedule',
    Empty: 'Empty',
    NonRefundable: 'NonRefundable'
} as const;

export type PolicyEnum = typeof PolicyEnum[keyof typeof PolicyEnum];


/**
 * room is fully refundable
 * @export
 * @interface PolicyFullyRefundable
 */
export interface PolicyFullyRefundable {
    'primaryText': string;
    'secondaryText'?: string;
    'Policy': CancellationPolicyForFEPolicyEnum;
}


export interface PolicyNonRefundable {
    'Policy': PolicyEnum;
}


/**
 * room is nonrefundable
 * @export
 * @interface PolicyNonRefundableFE
 */
export interface PolicyNonRefundableFE {
    'primaryText': string;
    'secondaryText'?: string;
    'Policy': CancellationPolicyForFEPolicyEnum;
}


/**
 * room is partially refundable
 * @export
 * @interface PolicyPartiallyRefundable
 */
export interface PolicyPartiallyRefundable {
    'primaryText': string;
    'secondaryText'?: string;
    'Policy': CancellationPolicyForFEPolicyEnum;
}


export interface PolicyUnknown {
    'primaryText': string;
    'Policy': CancellationPolicyForFEPolicyEnum;
}


/**
 * `total` - The full total price for the stay including all taxes and fees and discounts.
 * `taxes` - The breakdown of tax line items.
 * `nightly` - The nightly price including all taxes and fees and discounts.
 * `fees` - The breakdown of fee line items.
 * `discounts` - Any discounts applied to the stay's rent total. Clients should not subtract these from the rent themselves, as the rent total already includes these. They are provided for merchandising and tracking purposes only.
 * `currency` - The currency for this price
 * `rentTotal` - The total rent (i.e. base rate) for the stay including discounts, but excluding all taxes and fees.
 * @export
 * @interface Price
 */
export interface Price {
    'total': Prices;
    /**
     * The breakdown of tax line items.
     * @type {Array<Tax>}
     * @memberof Price
     */
    'taxes': Array<Tax>;
    'nightly': Prices;
    /**
     * The breakdown of fee line items.
     * @type {Array<Fee>}
     * @memberof Price
     */
    'fees': Array<Fee>;
    /**
     * Any discounts applied to the stay's rent total. Clients should not subtract these from the rent themselves, as the rent total already includes these. They are provided for merchandising and tracking purposes only.
     * @type {Array<Discount>}
     * @memberof Price
     */
    'discounts': Array<Discount>;
    /**
     * The currency for this price
     * @type {string}
     * @memberof Price
     */
    'currency': string;
    'rentTotal': Prices;
}
/**
 * Price in fiat currency as well as any with rewards/account specific currency
 * @export
 * @interface Prices
 */
export interface Prices {
    'fiat': FiatPrice;
    'accountSpecific': { [key: string]: AccountPrice; };
}
/**
 * Private host information for the listing.
 * @export
 * @interface PrivateHostInfo
 */
export interface PrivateHostInfo {
    'id': string;
    'name': string;
}
/**
 * Cancellation fulfillment failed to cancel the homes
 * @export
 * @interface ProductFailure
 */
export interface ProductFailure {
    'Aborted': AbortedEnum;
    'HomesCancelFulfillmentPollResponse': HomesCancelFulfillmentPollResponseEnum;
}


export const ProviderCategory = {
    B2B: 'B2B',
    Hopper: 'Hopper',
    OTA: 'OTA',
    Unspecified: 'Unspecified'
} as const;

export type ProviderCategory = typeof ProviderCategory[keyof typeof ProviderCategory];


/**
 * `price` - Price for the stay. Includes all taxes, fees, and discounts.
 * `cancellationPolicy` - Cancellation policy text for displaying to the user.
 * `trackingProperties` - Tracking properties associated with the rate
 * @export
 * @interface Rate
 */
export interface Rate {
    'price': Price;
    'cancellationPolicy': CancellationPolicyForFE;
    'trackingProperties': TrackingProperties;
}
export interface RatePolicy {
    'title': string;
    'text': string;
}
/**
 * @type Reason
 * @export
 */
export type Reason = { Reason: 'BlockedDates' } & ReasonBlockedDates | { Reason: 'CheckInNotAllowed' } & ReasonCheckInNotAllowed | { Reason: 'CheckOutNotAllowed' } & ReasonCheckOutNotAllowed | { Reason: 'Empty' } & ReasonEmpty | { Reason: 'MaxStayViolation' } & ReasonMaxStayViolation | { Reason: 'MinBookingWindowViolation' } & ReasonMinBookingWindowViolation | { Reason: 'MinStayViolation' } & ReasonMinStayViolation | { Reason: 'OccupancyViolation' } & ReasonOccupancyViolation | { Reason: 'PetPolicyViolation' } & ReasonPetPolicyViolation | { Reason: 'Unknown' } & ReasonUnknown;

export interface ReasonBlockedDates {
    'Reason': ReasonEnum;
}


export interface ReasonCheckInNotAllowed {
    'Reason': ReasonEnum;
}


export interface ReasonCheckOutNotAllowed {
    'Reason': ReasonEnum;
}


export interface ReasonEmpty {
    'Reason': ReasonEnum;
}


export const ReasonEnum = {
    BlockedDates: 'BlockedDates',
    CheckInNotAllowed: 'CheckInNotAllowed',
    CheckOutNotAllowed: 'CheckOutNotAllowed',
    Empty: 'Empty',
    MaxStayViolation: 'MaxStayViolation',
    MinBookingWindowViolation: 'MinBookingWindowViolation',
    MinStayViolation: 'MinStayViolation',
    OccupancyViolation: 'OccupancyViolation',
    PetPolicyViolation: 'PetPolicyViolation',
    Unknown: 'Unknown'
} as const;

export type ReasonEnum = typeof ReasonEnum[keyof typeof ReasonEnum];


export interface ReasonMaxStayViolation {
    'Reason': ReasonEnum;
}


export interface ReasonMinBookingWindowViolation {
    'Reason': ReasonEnum;
}


export interface ReasonMinStayViolation {
    'Reason': ReasonEnum;
}


export interface ReasonOccupancyViolation {
    'Reason': ReasonEnum;
}


export interface ReasonPetPolicyViolation {
    'Reason': ReasonEnum;
}


export interface ReasonUnknown {
    'Reason': ReasonEnum;
}


/**
 * Cancellation fulfillment failed to refund one or more payment method(s)
 * @export
 * @interface RefundFailure
 */
export interface RefundFailure {
    'Aborted': AbortedEnum;
    'HomesCancelFulfillmentPollResponse': HomesCancelFulfillmentPollResponseEnum;
}


/**
 * @type RegionType
 * @export
 */
export type RegionType = { RegionType: 'Airport' } & Airport | { RegionType: 'City' } & City | { RegionType: 'Unspecified' } & Unspecified;

export const RegionTypeEnum = {
    Airport: 'Airport',
    City: 'City',
    Unspecified: 'Unspecified'
} as const;

export type RegionTypeEnum = typeof RegionTypeEnum[keyof typeof RegionTypeEnum];


export interface ReservationDiscount {
    'discountType': DiscountKind;
    'hostFunded'?: DiscountFundedAmounts;
    'hopperFunded'?: DiscountFundedAmounts;
}


/**
 * @type ReservationStatus
 * @export
 */
export type ReservationStatus = { ReservationStatus: 'Cancelled' } & ReservationStatusCancelled | { ReservationStatus: 'Confirmed' } & ReservationStatusConfirmed | { ReservationStatus: 'Unknown' } & ReservationStatusUnknown;

export interface ReservationStatusCancelled {
    'ReservationStatus': ReservationStatusEnum;
}


export interface ReservationStatusConfirmed {
    'ReservationStatus': ReservationStatusEnum;
}


export const ReservationStatusEnum = {
    Cancelled: 'Cancelled',
    Confirmed: 'Confirmed',
    Unknown: 'Unknown'
} as const;

export type ReservationStatusEnum = typeof ReservationStatusEnum[keyof typeof ReservationStatusEnum];


export interface ReservationStatusUnknown {
    'ReservationStatus': ReservationStatusEnum;
}


export const ResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type ResponseEnum = typeof ResponseEnum[keyof typeof ResponseEnum];


/**
 * `bedrooms` - Filter to only listings with this range of bedrooms
 * `allAmenities` - Filter to listings with all of these amenities
 * `price` - Filter to only listings within this range of price
 * `bathrooms` - Filter to only listings with this range of bathrooms
 * `beds` - Filter to only listings with this range of beds
 * @export
 * @interface SearchFilters
 */
export interface SearchFilters {
    'bedrooms'?: UInt32Range;
    /**
     * Filter to listings with all of these amenities
     * @type {Array<AmenityFilter>}
     * @memberof SearchFilters
     */
    'allAmenities': Array<AmenityFilter>;
    'price'?: DoubleRange;
    'bathrooms'?: DoubleRange;
    'beds'?: UInt32Range;
}
/**
 * Token to be used to fetch the next page of results
 * @export
 * @interface SearchPageToken
 */
export interface SearchPageToken {
    'token': string;
}
/**
 * @type Selection
 * @export
 */
export type Selection = { Selection: 'Empty' } & SelectionEmpty | { Selection: 'ListingIds' } & SelectionListingIds | { Selection: 'PlaceId' } & SelectionPlaceId;

export interface SelectionEmpty {
    'Selection': SelectionEnum;
}


export const SelectionEnum = {
    Empty: 'Empty',
    ListingIds: 'ListingIds',
    PlaceId: 'PlaceId'
} as const;

export type SelectionEnum = typeof SelectionEnum[keyof typeof SelectionEnum];


/**
 * Select these specific listing IDs. Use this if you want to apply additional filter criteria to a set of known listings.
 * @export
 * @interface SelectionListingIds
 */
export interface SelectionListingIds {
    'listingIds': Array<ListingId>;
    'Selection': SelectionEnum;
}


/**
 * Select listings within a 1-degree bounding circle centered on this Google Place ID.
 * @export
 * @interface SelectionPlaceId
 */
export interface SelectionPlaceId {
    'placeId': string;
    'Selection': SelectionEnum;
}


/**
 * @type SettlementMethod
 * @export
 */
export type SettlementMethod = { SettlementMethod: 'Direct' } & Direct | { SettlementMethod: 'InterpolatedUserCard' } & InterpolatedUserCard | { SettlementMethod: 'Vcc' } & Vcc;

export const SettlementMethodEnum = {
    Direct: 'Direct',
    InterpolatedUserCard: 'InterpolatedUserCard',
    Vcc: 'Vcc'
} as const;

export type SettlementMethodEnum = typeof SettlementMethodEnum[keyof typeof SettlementMethodEnum];


/**
 * Request a given listing and return its availability

 * `listingId` - Listing ID to shop
 * `stayDetails` - Dates and guests to shop for
 * `distributionChannels` - Distribution Channels (Listing Collections) to shop
 * @export
 * @interface ShopRequest
 */
export interface ShopRequest {
    'listingId': ListingId;
    'stayDetails': StayDetails;
    /**
     * Distribution Channels (Listing Collections) to shop
     * @type {Array<DistributionChannel>}
     * @memberof ShopRequest
     */
    'distributionChannels': Array<DistributionChannel>;
}
/**
 * `listing` - Shopped listing result for the provided search criteria
 * `offers` - Shopped listing result for the provided search criteria
 * @export
 * @interface ShopResponse
 */
export interface ShopResponse {
    'listing': ListingSearchResult;
    'offers'?: HomesWalletOfferApplicabilityResponse;
}
export interface ShopResponseFailure {
    'errors': Array<ErrorCode>;
    'Response': ResponseEnum;
}


/**
 * @type ShopResponseResponse
 * @export
 */
export type ShopResponseResponse = { Response: 'Failure' } & ShopResponseFailure | { Response: 'Success' } & ShopResponseSuccess;

export interface ShopResponseSuccess {
    'value': ShopResponse;
    'Response': ResponseEnum;
}


/**
 * @type Specificity
 * @export
 */
export type Specificity = { Specificity: 'Approximate' } & Approximate | { Specificity: 'Exact' } & Exact;

export const SpecificityEnum = {
    Approximate: 'Approximate',
    Exact: 'Exact'
} as const;

export type SpecificityEnum = typeof SpecificityEnum[keyof typeof SpecificityEnum];


/**
 * Dates for the stay
 * @export
 * @interface StayDates
 */
export interface StayDates {
    'from': string;
    'until': string;
}
/**
 * `dateRange` - From and To date for the stay
 * `guestDetails` - Number of each type of guest and whether pets are included
 * @export
 * @interface StayDetails
 */
export interface StayDetails {
    'dateRange': StayDates;
    'guestDetails': GuestsSelection;
}
/**
 * Cancellation fulfillment succeeded
 * @export
 * @interface Success
 */
export interface Success {
    'HomesCancelFulfillmentPollResponse': HomesCancelFulfillmentPollResponseEnum;
}


/**
 * `kind` - The type of tax
 * `amount` - The amount of the tax
 * `name` - The name of the tax
 * `description` - The description of the tax
 * @export
 * @interface Tax
 */
export interface Tax {
    'kind': TaxKind;
    'amount': Prices;
    /**
     * The name of the tax
     * @type {string}
     * @memberof Tax
     */
    'name'?: string;
    /**
     * The description of the tax
     * @type {string}
     * @memberof Tax
     */
    'description'?: string;
}


/**
 * 

* `CityTaxes` - Local taxes
* `OccupancyFee` - General misc taxes collected by Hopper
* `SalesTax` - Sales tax assessed on the stay
* `TaxRecoveryCharges` - General misc taxes collected by the provider
 * @export
 * @enum {string}
 */

export const TaxKind = {
    CityTaxes: 'CityTaxes',
    OccupancyFee: 'OccupancyFee',
    SalesTax: 'SalesTax',
    TaxRecoveryCharges: 'TaxRecoveryCharges',
    Unknown: 'Unknown',
    Unrecognized: 'Unrecognized',
    Unspecified: 'Unspecified'
} as const;

export type TaxKind = typeof TaxKind[keyof typeof TaxKind];


export interface Text {
    'description'?: string;
    'PaymentClause': PaymentClauseEnum;
}


export interface TimeRange {
    'startTime'?: string;
    'endTime'?: string;
}
export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
export interface Transaction {
    'instigator': Instigator;
    'amount': number;
    'id': string;
    'createdAt': string;
    'currency': string;
    'reasonDescription'?: string;
}
/**
 * `min` - The lower bound of the range.
 * `max` - The upper bound of the range.
 * @export
 * @interface UInt32Range
 */
export interface UInt32Range {
    /**
     * The lower bound of the range.
     * @type {number}
     * @memberof UInt32Range
     */
    'min'?: number;
    /**
     * The upper bound of the range.
     * @type {number}
     * @memberof UInt32Range
     */
    'max'?: number;
}
export interface UnavailabilityReason {
    'reason': Reason;
    'debugDetails'?: string;
}
/**
 * Cancellation fulfillment failed due to unknown reason
 * @export
 * @interface UnknownFailure
 */
export interface UnknownFailure {
    'trackingProperties': TrackingProperties;
    'Aborted': AbortedEnum;
    'HomesCancelFulfillmentPollResponse': HomesCancelFulfillmentPollResponseEnum;
}


export interface Unspecified {
    'RegionType': RegionTypeEnum;
}


export interface UnspecifiedPaymentSchedule {
    'PaymentSchedule': PaymentScheduleEnum;
}


export interface Vcc {
    'SettlementMethod': SettlementMethodEnum;
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Request a list of available Homes and prices for given search criteria. Idempotent request.
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HomesAvailabilityPost: async (availabilityRequest: AvailabilityRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityRequest' is not null or undefined
            assertParamExists('apiV0HomesAvailabilityPost', 'availabilityRequest', availabilityRequest)
            const localVarPath = `/api/v0/homes/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(availabilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch unavailable date ranges for a given homes listing for a given date range
         * @param {GetCalendarAvailabilityRequest} getCalendarAvailabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HomesListingGetCalendarAvailabilityPut: async (getCalendarAvailabilityRequest: GetCalendarAvailabilityRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCalendarAvailabilityRequest' is not null or undefined
            assertParamExists('apiV0HomesListingGetCalendarAvailabilityPut', 'getCalendarAvailabilityRequest', getCalendarAvailabilityRequest)
            const localVarPath = `/api/v0/homes/listing/getCalendarAvailability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCalendarAvailabilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a given Home listing and return its availability with prices. Idempotent request.
         * @param {ShopRequest} shopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HomesShopPost: async (shopRequest: ShopRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopRequest' is not null or undefined
            assertParamExists('apiV0HomesShopPost', 'shopRequest', shopRequest)
            const localVarPath = `/api/v0/homes/shop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a manual Homes Cancel Fulfillment by sending a message to a Kustomer queue. Not an idempotent request, as each request will send another message to Kustomer. An agent will pick up this request and perform the cancellation and refund manually.
         * @param {HomesCancelAgentFulfillRequest} homesCancelAgentFulfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHomesCancelAgentFulfillPost: async (homesCancelAgentFulfillRequest: HomesCancelAgentFulfillRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'homesCancelAgentFulfillRequest' is not null or undefined
            assertParamExists('apiV0SelfserveHomesCancelAgentFulfillPost', 'homesCancelAgentFulfillRequest', homesCancelAgentFulfillRequest)
            const localVarPath = `/api/v0/selfserve/homes/cancelAgentFulfill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homesCancelAgentFulfillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a Homes Cancel Fulfillment using the quoteId from a Cancel Quote. Not an idempotent request, as a quoteId can only be fulfilled once, but subsequent calls with the same quoteId will fail rather than do something like over-refund. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesCancelFulfillRequest} homesCancelFulfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHomesCancelFulfillPost: async (homesCancelFulfillRequest: HomesCancelFulfillRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'homesCancelFulfillRequest' is not null or undefined
            assertParamExists('apiV0SelfserveHomesCancelFulfillPost', 'homesCancelFulfillRequest', homesCancelFulfillRequest)
            const localVarPath = `/api/v0/selfserve/homes/cancelFulfill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homesCancelFulfillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Poll the status of an existing Homes Cancel Fulfillment request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesCancelFulfillmentPollRequest} homesCancelFulfillmentPollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHomesCancelFulfillmentPollPut: async (homesCancelFulfillmentPollRequest: HomesCancelFulfillmentPollRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'homesCancelFulfillmentPollRequest' is not null or undefined
            assertParamExists('apiV0SelfserveHomesCancelFulfillmentPollPut', 'homesCancelFulfillmentPollRequest', homesCancelFulfillmentPollRequest)
            const localVarPath = `/api/v0/selfserve/homes/cancelFulfillmentPoll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homesCancelFulfillmentPollRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a Homes Cancel Quote, retrieving the cancellation policy and quoteId needed for Cancel Fulfillment. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesCancelQuoteRequest} homesCancelQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHomesCancelQuotePost: async (homesCancelQuoteRequest: HomesCancelQuoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'homesCancelQuoteRequest' is not null or undefined
            assertParamExists('apiV0SelfserveHomesCancelQuotePost', 'homesCancelQuoteRequest', homesCancelQuoteRequest)
            const localVarPath = `/api/v0/selfserve/homes/cancelQuote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homesCancelQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a Homes Change Quote, retrieving the cancellation policy and quoteId needed for Cancel Fulfillment, along with user-facing Copy to encourage cancel and rebook since homes bookings aren\'t typically changeable. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesChangeQuoteRequest} homesChangeQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHomesChangeQuotePost: async (homesChangeQuoteRequest: HomesChangeQuoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'homesChangeQuoteRequest' is not null or undefined
            assertParamExists('apiV0SelfserveHomesChangeQuotePost', 'homesChangeQuoteRequest', homesChangeQuoteRequest)
            const localVarPath = `/api/v0/selfserve/homes/changeQuote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homesChangeQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single home reservation for a given user
         * @param {GetHomeReservationRequest} getHomeReservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripsHomesGetReservationPut: async (getHomeReservationRequest: GetHomeReservationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getHomeReservationRequest' is not null or undefined
            assertParamExists('apiV0TripsHomesGetReservationPut', 'getHomeReservationRequest', getHomeReservationRequest)
            const localVarPath = `/api/v0/trips/homes/getReservation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getHomeReservationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all home reservations for a given user
         * @param {HomeItineraryRequest} homeItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripsHomesGetReservationsPut: async (homeItineraryRequest: HomeItineraryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'homeItineraryRequest' is not null or undefined
            assertParamExists('apiV0TripsHomesGetReservationsPut', 'homeItineraryRequest', homeItineraryRequest)
            const localVarPath = `/api/v0/trips/homes/getReservations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homeItineraryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Request a list of available Homes and prices for given search criteria. Idempotent request.
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0HomesAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0HomesAvailabilityPost(availabilityRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch unavailable date ranges for a given homes listing for a given date range
         * @param {GetCalendarAvailabilityRequest} getCalendarAvailabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0HomesListingGetCalendarAvailabilityPut(getCalendarAvailabilityRequest: GetCalendarAvailabilityRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCalendarAvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0HomesListingGetCalendarAvailabilityPut(getCalendarAvailabilityRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Request a given Home listing and return its availability with prices. Idempotent request.
         * @param {ShopRequest} shopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0HomesShopPost(shopRequest: ShopRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0HomesShopPost(shopRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Request a manual Homes Cancel Fulfillment by sending a message to a Kustomer queue. Not an idempotent request, as each request will send another message to Kustomer. An agent will pick up this request and perform the cancellation and refund manually.
         * @param {HomesCancelAgentFulfillRequest} homesCancelAgentFulfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SelfserveHomesCancelAgentFulfillPost(homesCancelAgentFulfillRequest: HomesCancelAgentFulfillRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomesCancelAgentFulfillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SelfserveHomesCancelAgentFulfillPost(homesCancelAgentFulfillRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Start a Homes Cancel Fulfillment using the quoteId from a Cancel Quote. Not an idempotent request, as a quoteId can only be fulfilled once, but subsequent calls with the same quoteId will fail rather than do something like over-refund. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesCancelFulfillRequest} homesCancelFulfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SelfserveHomesCancelFulfillPost(homesCancelFulfillRequest: HomesCancelFulfillRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomesCancelFulfillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SelfserveHomesCancelFulfillPost(homesCancelFulfillRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Poll the status of an existing Homes Cancel Fulfillment request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesCancelFulfillmentPollRequest} homesCancelFulfillmentPollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SelfserveHomesCancelFulfillmentPollPut(homesCancelFulfillmentPollRequest: HomesCancelFulfillmentPollRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomesCancelFulfillmentPollResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SelfserveHomesCancelFulfillmentPollPut(homesCancelFulfillmentPollRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Start a Homes Cancel Quote, retrieving the cancellation policy and quoteId needed for Cancel Fulfillment. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesCancelQuoteRequest} homesCancelQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SelfserveHomesCancelQuotePost(homesCancelQuoteRequest: HomesCancelQuoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomesCancelQuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SelfserveHomesCancelQuotePost(homesCancelQuoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Start a Homes Change Quote, retrieving the cancellation policy and quoteId needed for Cancel Fulfillment, along with user-facing Copy to encourage cancel and rebook since homes bookings aren\'t typically changeable. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesChangeQuoteRequest} homesChangeQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SelfserveHomesChangeQuotePost(homesChangeQuoteRequest: HomesChangeQuoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomesChangeQuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SelfserveHomesChangeQuotePost(homesChangeQuoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single home reservation for a given user
         * @param {GetHomeReservationRequest} getHomeReservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0TripsHomesGetReservationPut(getHomeReservationRequest: GetHomeReservationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomesReservation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0TripsHomesGetReservationPut(getHomeReservationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch all home reservations for a given user
         * @param {HomeItineraryRequest} homeItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0TripsHomesGetReservationsPut(homeItineraryRequest: HomeItineraryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeItineraryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0TripsHomesGetReservationsPut(homeItineraryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Request a list of available Homes and prices for given search criteria. Idempotent request.
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HomesAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: any): AxiosPromise<AvailabilityResponseResponse> {
            return localVarFp.apiV0HomesAvailabilityPost(availabilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch unavailable date ranges for a given homes listing for a given date range
         * @param {GetCalendarAvailabilityRequest} getCalendarAvailabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HomesListingGetCalendarAvailabilityPut(getCalendarAvailabilityRequest: GetCalendarAvailabilityRequest, options?: any): AxiosPromise<GetCalendarAvailabilityResponse> {
            return localVarFp.apiV0HomesListingGetCalendarAvailabilityPut(getCalendarAvailabilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Request a given Home listing and return its availability with prices. Idempotent request.
         * @param {ShopRequest} shopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HomesShopPost(shopRequest: ShopRequest, options?: any): AxiosPromise<ShopResponseResponse> {
            return localVarFp.apiV0HomesShopPost(shopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Request a manual Homes Cancel Fulfillment by sending a message to a Kustomer queue. Not an idempotent request, as each request will send another message to Kustomer. An agent will pick up this request and perform the cancellation and refund manually.
         * @param {HomesCancelAgentFulfillRequest} homesCancelAgentFulfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHomesCancelAgentFulfillPost(homesCancelAgentFulfillRequest: HomesCancelAgentFulfillRequest, options?: any): AxiosPromise<HomesCancelAgentFulfillResponse> {
            return localVarFp.apiV0SelfserveHomesCancelAgentFulfillPost(homesCancelAgentFulfillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start a Homes Cancel Fulfillment using the quoteId from a Cancel Quote. Not an idempotent request, as a quoteId can only be fulfilled once, but subsequent calls with the same quoteId will fail rather than do something like over-refund. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesCancelFulfillRequest} homesCancelFulfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHomesCancelFulfillPost(homesCancelFulfillRequest: HomesCancelFulfillRequest, options?: any): AxiosPromise<HomesCancelFulfillResponse> {
            return localVarFp.apiV0SelfserveHomesCancelFulfillPost(homesCancelFulfillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Poll the status of an existing Homes Cancel Fulfillment request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesCancelFulfillmentPollRequest} homesCancelFulfillmentPollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHomesCancelFulfillmentPollPut(homesCancelFulfillmentPollRequest: HomesCancelFulfillmentPollRequest, options?: any): AxiosPromise<HomesCancelFulfillmentPollResponse> {
            return localVarFp.apiV0SelfserveHomesCancelFulfillmentPollPut(homesCancelFulfillmentPollRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start a Homes Cancel Quote, retrieving the cancellation policy and quoteId needed for Cancel Fulfillment. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesCancelQuoteRequest} homesCancelQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHomesCancelQuotePost(homesCancelQuoteRequest: HomesCancelQuoteRequest, options?: any): AxiosPromise<HomesCancelQuoteResponse> {
            return localVarFp.apiV0SelfserveHomesCancelQuotePost(homesCancelQuoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start a Homes Change Quote, retrieving the cancellation policy and quoteId needed for Cancel Fulfillment, along with user-facing Copy to encourage cancel and rebook since homes bookings aren\'t typically changeable. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {HomesChangeQuoteRequest} homesChangeQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SelfserveHomesChangeQuotePost(homesChangeQuoteRequest: HomesChangeQuoteRequest, options?: any): AxiosPromise<HomesChangeQuoteResponse> {
            return localVarFp.apiV0SelfserveHomesChangeQuotePost(homesChangeQuoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a single home reservation for a given user
         * @param {GetHomeReservationRequest} getHomeReservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripsHomesGetReservationPut(getHomeReservationRequest: GetHomeReservationRequest, options?: any): AxiosPromise<HomesReservation> {
            return localVarFp.apiV0TripsHomesGetReservationPut(getHomeReservationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all home reservations for a given user
         * @param {HomeItineraryRequest} homeItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripsHomesGetReservationsPut(homeItineraryRequest: HomeItineraryRequest, options?: any): AxiosPromise<HomeItineraryResponse> {
            return localVarFp.apiV0TripsHomesGetReservationsPut(homeItineraryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Request a list of available Homes and prices for given search criteria. Idempotent request.
     * @param {AvailabilityRequest} availabilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0HomesAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0HomesAvailabilityPost(availabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch unavailable date ranges for a given homes listing for a given date range
     * @param {GetCalendarAvailabilityRequest} getCalendarAvailabilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0HomesListingGetCalendarAvailabilityPut(getCalendarAvailabilityRequest: GetCalendarAvailabilityRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0HomesListingGetCalendarAvailabilityPut(getCalendarAvailabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request a given Home listing and return its availability with prices. Idempotent request.
     * @param {ShopRequest} shopRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0HomesShopPost(shopRequest: ShopRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0HomesShopPost(shopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request a manual Homes Cancel Fulfillment by sending a message to a Kustomer queue. Not an idempotent request, as each request will send another message to Kustomer. An agent will pick up this request and perform the cancellation and refund manually.
     * @param {HomesCancelAgentFulfillRequest} homesCancelAgentFulfillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0SelfserveHomesCancelAgentFulfillPost(homesCancelAgentFulfillRequest: HomesCancelAgentFulfillRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0SelfserveHomesCancelAgentFulfillPost(homesCancelAgentFulfillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start a Homes Cancel Fulfillment using the quoteId from a Cancel Quote. Not an idempotent request, as a quoteId can only be fulfilled once, but subsequent calls with the same quoteId will fail rather than do something like over-refund. Investigate `/oklahomaOrder` page on the dashboard for failure details.
     * @param {HomesCancelFulfillRequest} homesCancelFulfillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0SelfserveHomesCancelFulfillPost(homesCancelFulfillRequest: HomesCancelFulfillRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0SelfserveHomesCancelFulfillPost(homesCancelFulfillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Poll the status of an existing Homes Cancel Fulfillment request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
     * @param {HomesCancelFulfillmentPollRequest} homesCancelFulfillmentPollRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0SelfserveHomesCancelFulfillmentPollPut(homesCancelFulfillmentPollRequest: HomesCancelFulfillmentPollRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0SelfserveHomesCancelFulfillmentPollPut(homesCancelFulfillmentPollRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start a Homes Cancel Quote, retrieving the cancellation policy and quoteId needed for Cancel Fulfillment. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
     * @param {HomesCancelQuoteRequest} homesCancelQuoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0SelfserveHomesCancelQuotePost(homesCancelQuoteRequest: HomesCancelQuoteRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0SelfserveHomesCancelQuotePost(homesCancelQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start a Homes Change Quote, retrieving the cancellation policy and quoteId needed for Cancel Fulfillment, along with user-facing Copy to encourage cancel and rebook since homes bookings aren\'t typically changeable. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
     * @param {HomesChangeQuoteRequest} homesChangeQuoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0SelfserveHomesChangeQuotePost(homesChangeQuoteRequest: HomesChangeQuoteRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0SelfserveHomesChangeQuotePost(homesChangeQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch a single home reservation for a given user
     * @param {GetHomeReservationRequest} getHomeReservationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0TripsHomesGetReservationPut(getHomeReservationRequest: GetHomeReservationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0TripsHomesGetReservationPut(getHomeReservationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all home reservations for a given user
     * @param {HomeItineraryRequest} homeItineraryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0TripsHomesGetReservationsPut(homeItineraryRequest: HomeItineraryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0TripsHomesGetReservationsPut(homeItineraryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



